import {
    CREATE_USER_SUCCESS,
    DELETE_USER_SUCCESS,
    FETCH_PROFILE,
    FETCH_PROFILE_FAILURE,
    FETCH_PROFILE_SUCCESS,
    FETCH_USER,
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    FETCH_USER_FAILURE,
    FETCH_USER_SUCCESS,
    SORT_ASC,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_USER_ACTIVITY_SUCCESS,
    UPDATE_USER_CONFIRMATION_SUCCESS,
    UPDATE_USER_SUCCESS,
    USERS_LIST_FILTER_UPDATE,
    USERS_LIST_FILTER_CATEGORY,
    USERS_LIST_PAGE,
    USERS_LIST_SORT,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'last_name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 24,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_PROFILE:
        case FETCH_USER:
        case FETCH_USERS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_PROFILE_FAILURE:
        case FETCH_USER_FAILURE:
        case FETCH_USERS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_USER_SUCCESS:
        case FETCH_PROFILE_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, { [action.response.id]: action.response }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_USERS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case CREATE_USER_SUCCESS:
        case UPDATE_USER_SUCCESS:
        case UPDATE_PROFILE_SUCCESS:
        case UPDATE_USER_ACTIVITY_SUCCESS:
        case UPDATE_USER_CONFIRMATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                loading: false,
            });

        case DELETE_USER_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case USERS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case USERS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case USERS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case USERS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/usersReducer.js